import { PropsWithChildren } from "react";
import { RetryButton } from "UIPalette/Buttons/RetryButton";
import ViewLoading from "shared/UI/Spinners/ViewLoading";
import { useAuthRefresh } from "core/auth/version2/useAuth/useAuthRefresh";
import { useMobilePlatform } from "core/hooks/useMobilePlatform";

type ViewStateWrapperProps = {
  loading: boolean;
  error: boolean;
  isFullScreenView?: boolean;
  onRetry: VoidFunction;
  errorMessage?: string;
} & PropsWithChildren;

export const ViewStateWrapper = ({ loading, error, isFullScreenView = false, onRetry, errorMessage, children }: ViewStateWrapperProps) => {
  const { isAuthV2 } = useMobilePlatform();
  const { isLoading, error: refreshError } = useAuthRefresh(isAuthV2 && !!error, onRetry);

  if (loading || isLoading) {
    return <ViewLoading containerClass={isFullScreenView ? "pt-72" : "h-full"} />;
  }

  if (error || refreshError) {
    return <RetryButton text={errorMessage} onClick={onRetry} className={isFullScreenView ? "pt-72" : ""} />;
  }

  return <>{children}</>;
};
